import script from "./SkuCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkuCard.vue?vue&type=script&lang=ts&setup=true"

import "./SkuCard.vue?vue&type=style&index=0&id=7ec4f96e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec4f96e"]])

export default __exports__